<template>
  <div class="content">
    <h3>
      买断
      <img
        src="../../../assets/game/gmTool/icon_update.png"
        alt=""
        @click="updateInfo"
        ref="reFreshbtn"
        class="rotate-image"
      />
    </h3>
    <div class="gm-box">
      <div class="game-info">
        <div class="game-serve" @click="selectType('role')">
          <p>选择角色</p>
          <p>
            <span v-if="state.roleInfo.roleid">
              {{ state.roleInfo.rolename }}&nbsp;[{{ state.roleInfo.zonename }}]
            </span>
            <span v-else> 选择角色后才可解锁权限</span>
            <svg
              width="10"
              height="6"
              viewBox="0 0 10 6"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                id="Polygon 8"
                d="M5.70345 5.30376C5.31378 5.68944 4.68622 5.68944 4.29655 5.30376L0.666294 1.71074C0.0313219 1.08228 0.476353 0 1.36975 0H8.63026C9.52365 0 9.96868 1.08228 9.33371 1.71074L5.70345 5.30376Z"
                fill="#666666"
              />
            </svg>
          </p>
        </div>
      </div>

      <div class="gm-tool">
        <div class="tool-content">
          <img src="../../../assets/game/gm_select_title.png" alt="" />
          <ul class="gm-type">
            <li
              v-for="(item, index) in state.authList"
              :key="index + '-authlist'"
              :class="{ active: index === state.authFlag }"
              @click="selectAuth(item, index)"
            >
              <div class="left">
                <p>{{ item.tier_name }}</p>
                <p v-show="item.kt == 1">已解锁</p>
                <p v-show="item.kt == 0">未解锁</p>
              </div>
            
            </li>
          </ul>
          <p>解锁最高档位可获得以上所有权限</p>
        </div>
        <div class="select-content">
          <ul class="gm-select">
            <li @click="selectType('goods')">
              <p>选择物品</p>
              <p>
                {{ goodsType.item_name }}
                <svg
                  width="10"
                  height="6"
                  viewBox="0 0 10 6"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    id="Polygon 8"
                    d="M5.70345 5.30376C5.31378 5.68944 4.68622 5.68944 4.29655 5.30376L0.666294 1.71074C0.0313219 1.08228 0.476353 0 1.36975 0H8.63026C9.52365 0 9.96868 1.08228 9.33371 1.71074L5.70345 5.30376Z"
                    fill="#666666"
                  />
                </svg>
              </p>
            </li>
          </ul>
          <i></i>
          <van-field
            v-model="state.goodsnum"
            :placeholder="state.numInputplaceholder"
            type="digit"
            @update:model-value="updateNum"
            @click-input="inputFocus"
            :disabled="state.inputFlag"
          />
        </div>
        <p @click="debounceSendGoods">发放</p>
      </div>
      <toolPop
        @closePop="closePopup"
        @updateTypename="updateName"
        :cacheList="state.cacheList"
        :popShow="state.popShow"
        :selectIndex="selectIndex"
        :popload="state.poploadFlag"
      >
        <template v-slot:title>
          <h1>{{ state.poptitle }}</h1>
        </template>
        <template v-slot:search>
          <div class="search" v-if="state.typeflag == 'goods'">
            <van-field
              v-model="state.searchText"
              @update:model-value="updateSearch"
              placeholder="请输入搜索内容"
              :border="false"
            />
            <p @click="goSearch">搜索</p>
          </div></template
        >
        <template v-slot:role="slotProps">
          <div class="role-info" v-if="state.typeflag == 'role'">
            <h4>
              {{ slotProps.item.rolename }}&nbsp;[{{ slotProps.item.zonename }}]
            </h4>
            <div class="center">
                <p> <span>小号:</span> {{ slotProps.item.nickname }}</p>
                <p class="pay"> <span>充值金额:</span> {{ slotProps.item.paymoney }}</p>
            </div>
            <p>角色ID:{{ slotProps.item.roleid }}</p>
          </div>
        </template>
        <template v-slot:goods="slotProps" v-if="state.typeflag == 'goods'">
          <h4 class="goods-info">{{ slotProps.data.item_name }}</h4>
        </template>
        <template v-slot:num="slotProps" v-if="state.typeflag == 'num'">
          <h4>{{ slotProps.data }}</h4>
        </template>
      </toolPop>
    </div>
  </div>
</template>
<script setup>
import { onActivated, reactive, ref, nextTick, onDeactivated } from "vue";
import toolPop from "./toolPop.vue";
const state = reactive({
  gid: "",
  ginfo: {
    gamename: "",
    id: "",
    pic1: "",
  },
  authFlag: 0,
  typeflag: "",

  roleInfo: {},
  rolelist: [],
  goodslist: [],

  authList: [],
  authType: {},
  overlayShow: true,
  popShow: false,

  searchText: "",
  goodsnum: "",
  inputFlag: true,
  numInputplaceholder: "请先选择物品",
  // 临时换存权限ID
  cacheAythtype: "",
  // 弹窗加载
  poploadFlag: false,

  isFirst: true
});

const goodsType = ref({
  max_quantity: "",
}); // 物品类型

import { Local } from "@/utils/storage";
import { detect } from "@/utils/device";
import router from "../../../router/index.js";
const goGmpay = (data) => {
  // 检验是否跳转支付
  if (getQueryString("ispay")) {
    // 检验角色信息是否存在
    if (!state.roleInfo.roleid) {
      Toast("请先选择角色");
      return;
    }
    const gmPayInfo = Object.assign({}, state.ginfo, data, state.roleInfo);
    Local.set("gmPayInfo", gmPayInfo);
    router.push({
      path: "/newGmPermissionOpen",
      query: {
        gid: state.gid,
        username: getQueryString("username"),
      },
    });
  } else {
    let nowDevice = detect();
    if (nowDevice == "android") {
      // Toast(`当前是哪种设备-----${nowDevice}`);
      window.location.href = "gogm://";
    } else {
      Toast(`请前往app内开通～`);
    }
  }
};

const selectAuth = (item, index) => {
  state.authType = item;
  state.authFlag = index;
  goodsType.value = {};
  state.goodsnum = "";
  state.inputFlag = true;
  state.numInputplaceholder = "请先选择物品";
};

// 决定子组件弹窗显示内容
const selectIndex = ref(0); // 当前选中的索引
const selectType = async (item) => {
  // console.log("选择类型", item);
  state.typeflag = item;
  switch (item) {
    case "role":
      state.poptitle = "角色选择";
      state.cacheList = state.rolelist;
      if (state.roleInfo.roleid) {
        // 寻找state.roleInfo在state.rolelist中的索引
        const roleindex = state.rolelist.findIndex(
          (role) => role.roleid === state.roleInfo.roleid
        );
        // 如果找到了对应的索引，则更新selectIndex的值
        if (roleindex !== -1) {
          selectIndex.value = roleindex;
        }
      } else {
        selectIndex.value = 0;
      }
      break;
    case "goods":
      // 如果不是同一个权限打开，清空搜索框
      if (state.cacheAythtype != state.authType.id) {
        state.searchText = "";
      }

      state.poptitle = "物品选择";
      if (state.goodslist[state.authType.id]) {
        // console.log("当前道具已经存在");
        state.cacheList = state.goodslist[state.authType.id];
      } else {
        await getGmgoods();
      }
      if (goodsType.value.item_name != " ") {
        // 寻找state.roleInfo在state.rolelist中的索引
        const goodsindex = state.goodslist[state.authType.id].findIndex(
          (item) => item.item_name === goodsType.value.item_name
        );
        // 如果找到了对应的索引，则更新selectIndex的值
        if (goodsindex !== -1) {
          selectIndex.value = goodsindex;
        }
      } else {
        selectIndex.value = 0;
      }
      break;
    default:
      break;
  }
  state.popShow = true;
};

const closePopup = () => {
  state.popShow = false;
  state.cacheList = [];
};

const updateName = (data) => {
  // console.log("子组件触发父组件更新名称", data);
  state.cacheList = [];
  state.popShow = false;
  if (state.typeflag === "role") {
    state.roleInfo = data;
    // console.log("角色信息", data);
    // 根据角色id获取对应的权限问题
    getGmdetails(data.roleid);
    return;
  } else if (state.typeflag === "goods") {
    goodsType.value = data;
    state.inputFlag = false;
    state.numInputplaceholder = "请输入数量(默认为1)";
    state.goodsnum = "";
    console.log("物品信息", goodsType.value);
    return;
  }
};
import { setToken } from "@/utils/auth";
onActivated(() => {
  if (getQueryString("token")) {
    setToken(getQueryString("token"));
  }
  // console.log("onActivated-------", window.navigator.appVersion);
  state.username = getQueryString("username");
  if (state.gid != getQueryString("gid")) {
    initInfo();
  }

  Local.remove("gmPayInfo");
  Local.remove("gmInfo");
  state.gid = getQueryString("gid");
  nextTick(() => {
    getGmdetails();
  });
});

const initInfo = () => {
  state.ginfo = {
    gamename: "",
    id: "",
    pic1: "",
  };
  state.authFlag = 0;
  state.typeflag = "";
  state.roleInfo = {};
  state.rolelist = [];
  state.overlayShow = true;
  goodsType.value = {};
  state.goodsnum = "";
  state.inputFlag = true;
  state.numInputplaceholder = "请先选择物品";
  state.cacheAythtype = "";
  state.popShow = false;
  state.goodslist = [];
};

import { getMdGame, getGmgoodsApi, mdGive } from "@/api/yzgame";
import { getQueryString } from "@/utils/location";
import { Toast } from "vant";
// 获取gm相关数据
const getGmdetails = async (id) => {
  try {
    let res = await getMdGame({
      username: state.username,
      gid: getQueryString("gid"),
      role_id: id ? id : state.roleInfo.roleid,
      xiaohao: state.roleInfo.xh,
    });
    if (res.data.code == 1) {
      state.ginfo = res.data.data.ginfo;
      state.authList = res.data.data.tiers;
      state.rolelist = res.data.data.partlists;
      // 初始化权限选择
      selectAuth(state.authList[state.authFlag], state.authFlag);
      // console.log("GM基本信息-----", res.data.data);


      if(state.rolelist.length > 0 && state.isFirst){
        state.typeflag = "role";
        updateName(state.rolelist[0])
        state.isFirst = false
      }

      if (updateFlag) {
        Toast("刷新成功");
      }
      updateFlag = false;
    } else {
      Toast(res.data.msg);
    }
    state.overlayShow = false;
  } catch (error) {
    console.log("error", error);
  }
};

// 搜索物品数据
const goSearch = () => {
  if (state.searchText) {
    if (state.goodslist[state.authType.id]) {
      state.cacheList = state.goodslist[state.authType.id].filter((item) =>
        item.item_name.includes(state.searchText)
      );
    }
    // console.log("搜索物品数据", state.cacheList);
  } else {
    Toast("请输入搜索内容");
  }
};
const updateSearch = (data) => {
  //输入框清空时恢复物品栏数据
  if (data == "") {
    state.cacheAythtype = undefined;
    state.cacheList = state.goodslist[state.authType.id];
  }
};

// 获取物品数据
const getGmgoods = async (data) => {
  state.popShow = true;
  state.poploadFlag = true;
  // state.cacheList = state.goodslist;
  try {
    let res = await getGmgoodsApi({
      gid: getQueryString("gid"),
      tier_id: state.authType.id,
      name: data,
    });
    // console.log("物品数据-----", res.data);
    if (res.data.code == 1) {
      state.cacheList = res.data.data;
      // 以state.authType.id为key，将数据存入state.goodslist中
      state.goodslist[state.authType.id] = res.data.data;
    } else {
      Toast(res.data.msg);
    }
    state.poploadFlag = false;
  } catch (error) {
    throw error;
  }
};

const inputFocus = () => {
  if (!goodsType.value.max_quantity) {
    Toast("请先选择物品");
  }
};
const updateNum = () => {
  if (state.goodsnum > goodsType.value.max_quantity) {
    Toast(`数量不能超过最大值${goodsType.value.max_quantity}`);
    state.goodsnum = goodsType.value.max_quantity;
  }
};
// 发放接口
/**
 * username  用户名
 * game_id  游戏id
 * role_id  角色id
 * number 数量
 * item_id  物品id
 * tier_id  权限id
 * item_name  物品名称
 * xiaohao 小号
 * zonid  区服zonid
 * type 物品类型
 */
import { debounce } from "@/utils/emojiToCode";
const sendGoods = async () => {
  try {
    let data = {
      username: state.username,
      game_id: getQueryString("gid"),
      role_id: state.roleInfo.roleid,
      number: state.goodsnum ? state.goodsnum : 1,
      item_id: goodsType.value.item_id,
      tier_id: state.authType.id,
      item_name: encodeURI(goodsType.value.item_name),
      xiaohao: state.roleInfo.xh,
      zoneid: state.roleInfo.zoneid,
      type: goodsType.value.type,
      itemstype: goodsType.value.itemstype,
    };
    let res = await mdGive(data);
    Toast(res.data.msg);
    console.log("发放物品", res);
  } catch (error) {
    console.log("error", error);
  }
};
const debounceSendGoods = debounce(sendGoods, 500);

var currentRotation = 0;
const reFreshbtn = ref(null);
var updateFlag = false;
const updateInfo = () => {
  updateFlag = true;
  // 旋转动画
  let rotateDom = reFreshbtn.value;
  currentRotation += 360;
  rotateDom.style.transform = "rotate(" + currentRotation + "deg)";
  getGmdetails();
};
</script>
<style scoped>
.content {
  height: 100vh;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  background-color: #161b1f;
  position: relative;
  padding-bottom: 280px;
}
.content h3 {
  text-align: center;
  margin-bottom: 36px;
  padding-top: 40px;
  background-color: #161b1f;
  color: #fff;
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  z-index: 2001;
  font-size: 32px;
}
.content h3 img {
  width: 28px;
  height: 28px;
  position: absolute;
  right: 32px;
  top: 58%;
}
.gm-box {
  flex: 1;
  display: flex;
  flex-direction: column;
}
.game-info {
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  width: 686px;
  height: 72px;
  padding: 0 32px;
  border-radius: 20px;
  background-color: #283138;
}

.game-serve {
  height: 100%;
  color: #fff;
  font-size: 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.game-serve p:nth-of-type(2) {
  color: #999999;
  display: flex;
  align-items: center;
}
.game-serve svg {
  margin-left: 18px;
}

.gm-tool {
  margin-top: 10px;
  padding: 28px 32px 0;
}
.gm-tool .tool-content > img {
  width: 606px;
  height: 28px;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  margin-bottom: 24px;
}
.gm-tool .gm-type {
  display: flex;
  overflow: auto;
}
.gm-type li {
  width: 242px;
  height: 120px;
  border-radius: 20px;
  background-color: #283138;
  margin: 0 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px 0 32px;
  position: relative;
  flex-shrink: 0;
  margin-right: 24px;
}
.gm-type li.active::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 4px solid #00d9c3;
  border-radius: 20px;
  z-index: 1;
}
.gm-type li p:nth-of-type(1) {
  color: #fff;
  font-size: 28px;
}
.gm-type li p:nth-of-type(2),
.gm-type li p:nth-of-type(3) {
  color: #00d9c3;
  font-size: 20px;
  margin-top: 4px;
}
.gm-type li p:nth-of-type(3) {
  color: #af6e21;
}

.gm-type li button {
  width: 80px;
  height: 80px;
  border-radius: 20px;
  border: none;
  color: #fff;
  background-color: #d9d9d9;
  font-size: 20px;
}
.gm-type li button.auth-lock {
  background: linear-gradient(270deg, #00d9c3 0%, #20c2df 100%);
  white-space: wrap;
  padding: 0 14px;
  position: relative;
  z-index: 3;
}

.select-content {
  margin-top: 32px;
  background-color: #283138;
  border-radius: 20px;
}
.select-content i {
  width: 622px;
  height: 2px;
  background: #5c5c5c;
  display: block;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
}
.gm-tool :deep(.van-cell),
.gm-select li {
  width: 686px;
  height: 84px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 32px;
  background-color: #283138;
  border-radius: 20px;
  font-size: 24px;
}
:deep(.van-field__control) {
  color: #fff;
}
.gm-select p {
  display: flex;
  align-items: center;
  color: #fff;
}
.gm-select p svg {
  margin-left: 18px;
}
.gm-tool .tool-content > p:nth-of-type(1) {
  color: #00d9c3;
  text-align: center;
  font-size: 24px;
}
.gm-tool > p:last-child {
  margin-top: 44px;
  width: 686px;
  height: 96px;
  background: linear-gradient(90deg, #00d9c5 0%, #20c3de 100%);
  border-radius: 20px 20px 20px 20px;
  text-align: center;
  line-height: 96px;
  font-size: 36px;
  color: #fff;
  font-weight: 800;
  position: fixed;
  bottom: 40px;
  z-index: 99;
}
.rotate-image {
  transition: transform 0.5s;
}

.role-info .center {
  display: flex;
  align-items: center;
  margin-top: 6px;
  margin-bottom: 6px;
}
.role-info .center .pay {
  margin-left: 12px;
}
</style>
